import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { HiX } from 'react-icons/hi';
import './Modal.css';

/**
 * Project-wide modal shell:
 * - Fixed header (always visible)
 * - Scrollable body with hidden scrollbar
 * - Optional footer
 */
export default function Modal({
  open,
  onClose,
  eyebrow,
  title,
  subtitle,
  icon,
  children,
  footer,
  wide,
  className,
}) {
  return (
    <AnimatePresence>
      {open ? (
        <motion.div
          className="modal-backdrop"
          onClick={onClose || undefined}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className={`modal${wide ? ' modal--wide' : ''}${className ? ` ${className}` : ''}`}
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, y: 24, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.98 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            role="dialog"
            aria-modal="true"
            aria-label={typeof title === 'string' ? title : 'Dialog'}
          >
            <header className="modal__header">
              {onClose ? (
                <button className="modal__close" type="button" onClick={onClose} aria-label="Close">
                  <HiX size={20} />
                </button>
              ) : null}
              {icon ? <div className="modal__icon">{icon}</div> : null}
              {eyebrow ? <div className="modal__eyebrow">{eyebrow}</div> : null}
              {title ? <h2 className="modal__title">{title}</h2> : null}
              {subtitle ? <p className="modal__subtitle">{subtitle}</p> : null}
            </header>

            <div className="modal__body">{children}</div>

            {footer ? <footer className="modal__footer">{footer}</footer> : null}
          </motion.div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
